<template>
    <teleport to="#modal-vue">
        <CModal
            alignment="center"
            scrollable
            :visible="modalActive"
            aria-labelledby="VerticallyCenteredModal"
            @close="() => { modalActive = false }"
        >
            <CModalHeader>
                <CModalTitle id="VerticallyCenteredModal"/>
            </CModalHeader>
            <CModalBody>
                <slot>
                    <div v-html="content" />
                </slot>
            </CModalBody>
        </CModal>
    </teleport>
</template>

<script>
import { CModal, CModalBody, CModalHeader, CModalTitle } from '@coreui/vue';
import $ from 'jquery';
import { ref } from 'vue';

export default {
	name: 'TextpicModal',
	components: { CModal, CModalBody, CModalTitle, CModalHeader },

	setup() {
		const content = ref('');
		const modalActive = ref(false);

		setTimeout(() => {
			$('.ce-textpic.clickable-modal').on('click', function () {
				content.value = $(this).find('.textpic-modal').data('modal-content');
				modalActive.value = true;
			});
		}, 500);

		return {
			modalActive,
			content,
		};
	},
};
</script>

